import { render } from "./FinancialDashboard.vue?vue&type=template&id=12164e1a&scoped=true"
import script from "./FinancialDashboard.vue?vue&type=script&lang=js"
export * from "./FinancialDashboard.vue?vue&type=script&lang=js"

import "./FinancialDashboard.vue?vue&type=style&index=0&id=12164e1a&scoped=true&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12164e1a"]])

export default __exports__